import {tasksList_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/tasksList_template";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";



declare var ko: any;
declare var page: any;

export class tasks extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected tasksList: tasksList_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlListData: XMLHttpRequestHandler;
    protected XHRHdlRescheduleTask: XMLHttpRequestHandler;
    protected XHRHdlSaveRescheduleTask: XMLHttpRequestHandler;
    protected validationsList: validationsList_template;

    //
    // implementation of base class [vnModule]
    protected getModuleName(): string{

        return "tasks";
    }

    //
    // implementation of base class [vnModule]
    public buildContent() : Array<Element>{

        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        this.tasksList = new tasksList_template("tasks", this.viewModel, this)
        this.template = this.tasksList;
        this.tasksList.setHasTagFilter(true);

        return [this.validationsList.build(), this.tasksList.build()];
    }

    // implementation of base class [vnModule]
    public fillPage(): void {

        this.getListFormData();
    }

    //
    // required from template [usersList_template]
    public paginationOnPageClick(): void {

        this.getListData();
    }

    //
    // required from template [accountsList_template]
    protected reorderTasks(): void {

        this.getListData();
    }

    protected getListFormData(): void {

        let usrReq_url: string = '/api/tasks/references/';
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj): Function {

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    obj.updateFilters(responseParsed);
                    obj.updateViewModelFromPath();
                    obj.getListData();
                    obj.getSearchPresetsListData();
                }
            });
        }
    }

    public getListData(): void {

        if( this.XHRHdlListData ){

            this.XHRHdlListData.cancelAndReset();
        }

        let subViewModel = this.tasksList.getViewModelForRequest();
        //console.log(subViewModel);

        let usrReq_url: string = '/api/tasks/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdlListData = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        // this.XHRHdlListData.onReadyStateFunction = this.onDataRequestReturn;
        // this.XHRHdlListData.execute();
        this.sendFilterCall(usrReq_url, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'tasks',this.tasksList.builtTemplate.querySelector("#list-results-body"));

    }

    /**
     * @param req
     * @param obj
     * @protected
     */
    protected onDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){
                const responseParsed = JSON.parse(req.request.response);
                const execTime = Math.round((new Date().getTime() - req._requestStartTime)/1000*100)/100;
                obj.updateList(responseParsed, execTime);
                obj.loadingOut(obj.tasksList.builtTemplate.querySelector("#list-results-body"));
                obj.tasksList.autoRefresh.callRefresh();
            });
        }
    }

    protected onUpdateError(): void {

    }

    protected errorHandler(req, obj): void {

        obj.getVnAppZone().showNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, "An error occured."));
        console.log("ERROR");
    }

    protected updateList(responseParsed: any, execTime = 0): void {

        this.tasksList.setPagination(responseParsed.totalCount);
        this.tasksList.setResultPage(responseParsed.totalCount, execTime);

        let tasks = [];
        if( responseParsed.data && responseParsed.data.length > 0 ){
            tasks = responseParsed.data.map(item => {
                let task = item['0'];
                if(task.dateExecuted && task.formattedDateUpdated) {
                    const dateUpdate = new Date(task.formattedDateUpdated);
                    const dateExecuted = new Date(task.dateExecuted);
                    const diff = dateUpdate.getTime() - dateExecuted.getTime();

                    const hours = Math.floor(diff / 1000 / 60 / 60);
                    const formattedHours = (hours.toString().length < 2 ? '0'.repeat(2 - hours.toString().length) : '') + hours.toString();
                    const minutes = Math.floor((diff - (hours * 1000 * 60 * 60)) / 1000 / 60);
                    const formattedMinutes = (minutes.toString().length < 2 ? '0'.repeat(2 - minutes.toString().length) : '') + minutes.toString();
                    const seconds = Math.floor((diff - (hours * 1000 * 60 * 60) - (minutes * 1000 * 60)) / 1000);
                    const formattedSeconds = (seconds.toString().length < 2 ? '0'.repeat(2 - seconds.toString().length) : '') + seconds.toString();

                    task.executionTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
                } else {
                    task.executionTime = ``;
                }

                return task;
            });
        }

        this.tasksList.setTasks(tasks);
    }

    public filterDropDownOnChange(): number {

        return 1;
    }

    // required from template [tasksList_template]
    protected filterSimpleOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected updateFilters(responseParsed: any): void {

        this.tasksList.setSearchableFields(['operation name', 'taskExecuter name', 'task extraInfo']);
        this.tasksList.setOperationFilterItems(responseParsed.operations);
        this.tasksList.setStatusFilterItems(responseParsed.status);
        this.tasksList.setBrandFilterItems(responseParsed.brands);
        this.tasksList.setPipelineFilterItems(responseParsed.pipelines);
        this.tasksList.setUpdateStatuses(responseParsed.updateStatuses);
        this.tasksList.setIdUpdateDelete(responseParsed.idUpdateDelete);
        this.tasksList.setPermissions(responseParsed.permissions);
    }


    public filterDropdownOnChange(elem): void {

        if (elem != "updateStatuses") {

            this.tasksList.resetPageNumber();
            this.tasksList.resetOrderParameters();
            this.getListData();
        }
    }

    public filterSingleGroupSelectorOnChange(elem): void {

        this.tasksList.resetPageNumber();
        this.tasksList.resetOrderParameters();
        this.getListData();

    }

    public filterMultipleSelectorOnChange(elem): void {
        this.tasksList.resetPageNumber();
        this.tasksList.resetOrderParameters();
        this.getListData();
    }

    public filterAutoRefreshStatusOnChange(){
        this.tasksList.resetPageNumber()
        this.tasksList.resetOrderParameters()
        this.getListData()
    }

    protected getTagsSuggestionOnInput(keyword, limit, tagType, getSelectable, getNonSelectable, imageAndSpecSelectable, specFields = false) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword, limit: limit, idTagType: tagType ? tagType.id : null, getSelectable:getSelectable, getNonSelectable:getNonSelectable, imageAndSpecSelectable: imageAndSpecSelectable, specFields: specFields} };

        let usrReq_url: string = '/api/search/tag/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags)
                {
                    responseParsed.data.tags.forEach(function (tag) {
                        tag.name += tag.formattedTagTypeAndDataset ? ` ${tag.formattedTagTypeAndDataset}` : '';
                    })
                    obj.tasksList.setPrimaryTagsFilterItems(responseParsed.data.tags);
                }

            });
        }
    }

    private resetPageNumber(){
        // go back to page 1 in the pagination
        this.viewModel.tasks.pagination.pageNumber(1);
    }

    public filterSimpleCancel(): void {

    }

    protected getMultipleAutoCompleteSuggestions(idSourceElement, keyword): void{
        switch (idSourceElement) {
            case 'filterTag':
                this.getTagsSuggestionOnInput(keyword, 5, null, true, false, false);
                break;
            case 'executerFilterAutocomplete':
                this.getTaskExecuterSuggestions(keyword, idSourceElement, 5);
                break;
            default:
                console.log(`getMultipleAutoCompleteSuggestions not implemented for ${idSourceElement}`);
                break;
        }
    }

    protected onAutocompleteInputClear(idElement) {
        this.getListData();
    }

    protected onAutocompleteInputClick(idElement) {
    }

    protected onAutocompleteOptionChange(idElement) {
        this.getListData();
    }

    private getTaskExecuterSuggestions(keyword, idSourceElement, limit = 5) {
        if( idSourceElement in this.XHRHdls ){
            this.XHRHdls[idSourceElement].cancelAndReset();
        }

        let subViewModel = {filter: {
            keyword: keyword,
            limit: limit || 5,
        } };

        let req_url: string = '/api/task-executer/search/';
        let req_params: Array<Array<string>> = [];
        req_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls[idSourceElement] = new XMLHttpRequestHandler(req_url, req_params, this);
        this.XHRHdls[idSourceElement].onReadyStateFunction = this.onGetTaskExecuterSuggestionsReturn;
        this.XHRHdls[idSourceElement].execute();
    }

    private onGetTaskExecuterSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.taskExecuters)
                {
                    obj.tasksList.executerAutocomplete.setItems(responseParsed.data.taskExecuters);
                }
            });
        }
    }

    protected deleteTask(task: any): void {

        let formReq_params: Array<Array<string>> = [];

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/tasks/delete/'+task. id , formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onDeleteReturn;
        XHRHdl.execute();
    }

    /**
     * Handles delete response.
     *
     * @param req
     * @param obj
     * @return {function(): void}
     */
    protected onDeleteReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Task deleted successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.validationsList.clearMessages();

                obj.getListData();
            });
        }
    }


    protected rescheduleTask(): void {

        this.loadingIn(this.tasksList.builtTemplate.children.namedItem("timeline"));

        if( this.XHRHdlRescheduleTask ){

            this.XHRHdlRescheduleTask.cancelAndReset();
        }

        let subViewModel = this.tasksList.getViewModelForRequest();

        let usrReq_url: string = '/api/tasks/rescheduleBlocks/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdlRescheduleTask = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdlRescheduleTask.onReadyStateFunction = this.onRescheduleTaskReturn;
        this.XHRHdlRescheduleTask.execute();
    }

    protected onRescheduleTaskReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.tasksList.setTimeline(responseParsed.timeline);
            });

            obj.loadingOut(obj.tasksList.builtTemplate.children.namedItem("timeline"));
        }
    }


    protected saveRescheduleTask(): void {

        this.loadingIn(this.tasksList.builtTemplate.children.namedItem("timeline"));

        if( this.XHRHdlSaveRescheduleTask ){

            this.XHRHdlSaveRescheduleTask.cancelAndReset();
        }

        let subViewModel = this.tasksList.getViewModelForRequest();

        let usrReq_url: string = '/api/tasks/reschedule/save/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdlSaveRescheduleTask = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdlSaveRescheduleTask.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdlSaveRescheduleTask.onReadyStateFunction = this.onSaveRescheduleTaskkReturn;
        this.XHRHdlSaveRescheduleTask.execute();
    }

    protected onSaveRescheduleTaskkReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                //let responseParsed = JSON.parse(req.request.response);
                obj.loadingOut(obj.tasksList.builtTemplate.children.namedItem("timeline"));

                obj.tasksList.onClickCancelReschedule();

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Task rescheduled successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.validationsList.clearMessages();

                obj.getListData();

            });

        }
    }

    protected updateTask(ids, idStatus): void {

        let formReq_params: Array<Array<string>> = [];
        let data = {ids: ids, idStatus: idStatus};

        formReq_params.push(["data", ko.toJSON(data)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/tasks/update/' , formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onUpdateReturn;
        XHRHdl.execute();
    }

    /**
     * Handles delete response.
     *
     * @param req
     * @param obj
     * @return {function(): void}
     */
    protected onUpdateReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Task updated successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.validationsList.clearMessages();

                obj.getListData();
            });
        }
    }

    /**
     * Hook.
     *
     * Redirects to create task page.
     */
    protected addTask(): void{
        let addTaskUrl = window.location.origin+'/tasks/add';
        this.savePreviousPage(addTaskUrl, window.location.href);
        page('/tasks/add');
    }

    public autoRefresh(){
        this.getListData();
    }


    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subVM = JSON.parse(ko.toJSON(this.tasksList.getViewModelForRequest()));
        let url: string = '/api/search_preset/get/';
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(subVM)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(url, params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.tasksList.setSearchPresets(response);
                // obj.filterList();
            });
        }
    }


    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let url: string = '/api/search_preset/save';
        let params: Array<Array<string>> = [];

        let subVM = JSON.parse(ko.toJSON(this.tasksList.getViewModelForRequest()));

        params.push(["data", ko.toJSON(subVM)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(url,params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetTasks
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetTasks(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.tasksList.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);

            });
        }
    }

    protected setDefaultStatusFilters(){
        console.debug("Not implemented");
    }

    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.getListData();
    }

    protected filterByPresets(filters){

        this.tasksList.setViewModelFromRequest(filters);
        this.getListData();
    }

}


// WEBPACK FOOTER //
// ./js/modules/tasks.ts